import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import Image from 'components/Image';

class Banner extends React.PureComponent {
  render() {
    const {
      data,
      data: { imgsize, resizemode, width, hl, imgid },
    } = this.props;
    const s = this.props.styleObj;
    if (data && data.imgid) {
      const customclass = data.extclass ? s[data.extclass] : '';
      return (
        <Link
          to={data.wu}
          className={`${s.banner} ${customclass}`}
          title={data.hl}
          data-ga={data.ga}
          spa={data.isspa === '1'}
          target={data.issametab ? '' : '_blank'}
        >
          {width && resizemode ? (
            <Image
              msid={imgid}
              resizemode={resizemode}
              imgsize={imgsize}
              alt={hl}
              width={width}
            />
          ) : (
            <Image
              src={`https://static.toiimg.com/photo/${data.imgid}.cms`}
              alt={data.hl}
            />
          )}
        </Link>
      );
    }
    return null;
  }
}
Banner.propTypes = {
  data: PropTypes.shape({
    imgid: PropTypes.string,
    wu: PropTypes.string,
    ga: PropTypes.string,
    isspa: PropTypes.bool,
    extclass: PropTypes.string,
    issametab: PropTypes.bool,
  }),
  styleObj: PropTypes.shape({}).isRequired,
};

Banner.defaultProps = {
  data: {},
};
export default Banner;
